var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { Agent } from '../classes/agent';
import { Listing } from '../classes/listing';
import { HttpParams } from '@angular/common/http';
import { Helper } from '../classes/helper';
import { CacheService } from './cache.service';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import { PreferencesService } from './preferences.service';
import { HasSubscriptions } from '../components/has-subscriptions';
import { ListingCategory } from '../classes/enums';
var AgentService = /** @class */ (function (_super) {
    __extends(AgentService, _super);
    function AgentService(appConfig, http, cache, apiConfig, preferencesService) {
        var _this = _super.call(this) || this;
        _this.appConfig = appConfig;
        _this.http = http;
        _this.cache = cache;
        _this.apiConfig = apiConfig;
        _this.preferencesService = preferencesService;
        _this._favouriteListings = [];
        _this._favouriteAgents = [];
        _this._randomSeed = '' + new Date().getTime();
        _this.addSub(_this.preferencesService.favouriteListingsChanged.subscribe(function (favourites) { return _this._favouriteListings = favourites; }));
        _this.addSub(_this.preferencesService.favouriteAgentsChanged.subscribe(function (favourites) { return _this._favouriteAgents = favourites; }));
        return _this;
    }
    AgentService.prototype.getAgentDetails = function (agentId, isSourceSystemId) {
        var _this = this;
        var params = new HttpParams()
            .set((isSourceSystemId ? 'sourceSystemId' : 'prefixedid'), '' + agentId);
        var base = this.getBaseUrl(this.appConfig.urls.agent.base);
        var route = this.appConfig.urls.agent.base;
        var hashKey = this.cache.getRequestHash(route, params);
        var hashValue = this.cache.get(hashKey);
        if (hashValue) {
            return of(new Agent(hashValue, this._favouriteAgents));
        }
        return this.http.get(base + route, { params: params, withCredentials: true })
            .pipe(tap(function (res) { return _this.cache.set(hashKey, res.result, 300, false); }), map(function (res) { return new Agent(res.result, _this._favouriteAgents); }));
    };
    AgentService.prototype.getFilters = function (propType) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = new HttpParams()
                            .set('category', propType === ListingCategory.COMMERCIAL ? 'Commercial' : 'Residential');
                        return [4 /*yield*/, this.http.get(this.getBaseUrl(this.appConfig.urls.agent.filters) + this.appConfig.urls.agent.filters, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                var filters = res.result;
                                filters.specialties.sort(function (o1, o2) { return o1 > o2 ? 1 : -1; });
                                filters.languages.sort(function (o1, o2) { return o1 > o2 ? 1 : -1; });
                                return filters;
                            }))
                                .toPromise()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a paginated list of listings for an agent
     * @param remaxAgentId
     * @param pagination
     */
    AgentService.prototype.getListingsPreviewsForAgent = function (remaxAgentId, pagination) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var params, base, route, hashKey, hashValue, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this._setSearchParams(pagination);
                        base = this.getBaseUrl(this.appConfig.urls.agent.listings);
                        route = this.appConfig.urls.agent.listings + remaxAgentId;
                        hashKey = this.cache.getRequestHash(route, params);
                        hashValue = this.cache.get(hashKey);
                        // FIXME: Favourites are not loading properly
                        if (hashValue) {
                            hashValue.results = hashValue.results.map(function (listing) { return new Listing(listing, _this._favouriteListings); });
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        return [4 /*yield*/, this.http.get(base + route, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                res.result.results = res.result.results.map(function (r) { return new Listing(r, _this._favouriteListings); });
                                _this.cache.set(hashKey, res.result, 300);
                                return res.result;
                            }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Searches across all Agents
     * @param pagination
     * @param searchParams
     */
    AgentService.prototype.getAgents = function (pagination, searchParams, listingCategory) {
        return __awaiter(this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!searchParams.randomSeed) {
                            searchParams.randomSeed = this._randomSeed;
                        }
                        params = Helper.setSearchParams(pagination, searchParams, listingCategory);
                        return [4 /*yield*/, this.http.get(this.getBaseUrl(this.appConfig.urls.agent.search) + this.appConfig.urls.agent.search, { params: params, withCredentials: true })
                                .pipe(map(function (res) {
                                res.result.results = res.result.results ? res.result.results.map(function (o) { return new Agent(o); }) : [];
                                return res.result;
                            }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Returns the total number of agents for a specific, province, city or for the whole country
     * If province and city and not passed in, will search for all of canada
     * @param province
     * @param city
     */
    AgentService.prototype.getAgentCount = function (province, city) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, hashKey, hashValue, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.agent.count);
                        route = this.appConfig.urls.agent.count;
                        if (province)
                            route += province;
                        if (city)
                            route += '/' + city;
                        hashKey = this.cache.getRequestHash(route);
                        hashValue = this.cache.get(hashKey, true);
                        if (hashValue) {
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        url = base + route;
                        return [4 /*yield*/, this.http.get(url, { withCredentials: true })
                                .pipe(tap(function (res) { return _this.cache.set(hashKey, res.result, 300, true); }), map(function (res) { return res.result; }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AgentService.prototype._setSearchParams = function (pagination) {
        var params = new HttpParams();
        if (pagination) {
            params = params.append('from', (pagination.offset).toString());
            params = params.append('size', pagination.limit.toString());
        }
        return params;
    };
    AgentService.prototype.getBaseUrl = function (route) {
        return this.apiConfig.getServerRoot(route);
    };
    AgentService.prototype.getAgentConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var base, route, hashKey, hashValue, url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base = this.getBaseUrl(this.appConfig.urls.agent.config);
                        route = this.appConfig.urls.agent.config;
                        hashKey = this.cache.getRequestHash(route);
                        hashValue = this.cache.get(hashKey, true);
                        if (hashValue) {
                            return [2 /*return*/, new Promise(function (resolve) {
                                    resolve(hashValue);
                                })];
                        }
                        url = base + route;
                        return [4 /*yield*/, this.http.get(url, { withCredentials: true })
                                .pipe(tap(function (res) { return _this.cache.set(hashKey, res.result, 3600, true); }), map(function (res) { return res.result; }))
                                .toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return AgentService;
}(HasSubscriptions));
export { AgentService };
